<template>

    <v-page-section>
        <template #title>Commission</template>
        <template #body>
            <v-form-group label="Your Stats" caption="You are enrolled to earn 30% commission payable each month for every paying customer you refer to CrowdPower.">
                <v-list grouped>
                    <v-list-item>
                        <span>Visitors<i class="fa-solid fa-circle-info" v-tooltip="{ content: 'People who visited from your referral link.', trigger: 'hover', offset: 5 }" /></span>
                        <span class="text-primary">{{ referrals.visitors | numeral('0,0') }}</span>
                    </v-list-item>
                    <v-list-item>
                        <span>Leads<i class="fa-solid fa-circle-info" v-tooltip="{ content: 'People who upgraded their plan.', trigger: 'hover', offset: 5 }" /></span>
                        <span class="text-primary">{{ referrals.leads | numeral('0,0') }}</span>
                    </v-list-item>
                    <v-list-item>
                        <span>Conversions<i class="fa-solid fa-circle-info" v-tooltip="{ content: 'People who paid for a plan.', trigger: 'hover', offset: 5 }" /></span>
                        <span class="text-primary">{{ referrals.conversions | numeral('0,0') }}</span>
                    </v-list-item>
                    <v-list-item>
                        <span>Gross Revenue<i class="fa-solid fa-circle-info" v-tooltip="{ content: 'Revenue attributed to you.', trigger: 'hover', offset: 5 }" /></span>
                        <span class="text-primary">{{ commission.gross_revenue.cents | currency }}</span>
                    </v-list-item>
                    <v-list-item>
                        <span>Net Revenue<i class="fa-solid fa-circle-info" v-tooltip="{ content: 'Revenue owed to you.', trigger: 'hover', offset: 5 }" /></span>
                        <span class="text-primary">{{ commission.net_revenue.cents | currency }}</span>
                    </v-list-item>
                    <v-list-item>
                        <span>Paid<i class="fa-solid fa-circle-info" v-tooltip="{ content: 'Commission paid to you.', trigger: 'hover', offset: 5 }" /></span>
                        <span class="text-primary">{{ commission.paid.cents | currency }}</span>
                    </v-list-item>
                    <v-list-item>
                        <span>Unpaid<i class="fa-solid fa-circle-info" v-tooltip="{ content: 'Commission due to you.', trigger: 'hover', offset: 5 }" /></span>
                        <span class="text-primary">{{ commission.unpaid.cents | currency }}</span>
                    </v-list-item>
                </v-list>
            </v-form-group>
        </template>
    </v-page-section>

</template>

<style scoped lang="scss">

    i {
        cursor: pointer;
        margin-left: 5px;
        opacity: 0.5;
        transition: opacity .3s;
        &:hover {
            opacity: 1;
        }
    }

</style>

<script>

export default {

    props: {
        affiliate: {
            type: Object,
            required: true,
        },
    },

    computed: {

        referrals() {
            return this.affiliate.links[0];
        },

        commission() {
            return this.affiliate.commission_stats.currencies.USD;
        },

    },

}

</script>